<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <el-row type="flex" justify="left">
      <lz-form
        ref="form"
        :get-data="getData"
        :disable-stay="false"
        :submit="onSubmit"
        :form.sync="form"
        :errors.sync="errors"
        :edit-mode="editMode"
      >
        <el-form-item label="发送场景" required prop="scene_type">
          <el-select v-model="form.scene_type" @change="showSceneTypeTag" :disabled="editMode ? true : false" filterable clearable>
            <el-option v-for="i of sceneTypeOptions" :key="i.id" :label="i.name" :value="i.id">
              <span>{{ i.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="模板ID" prop="template_id">
          <el-input v-model="form.template_id" />
        </el-form-item>
        <el-form-item label="本地对象可用标签">
          <el-tag v-for="(val, index) in sceneTypeTag" :key="index" size="medium" type="info">{{ val }}</el-tag>
        </el-form-item>

        <el-form-item label="模板标签映射" required>
          <el-col>
            <el-button size="mini" type="primary" @click="addMapping" plain>添加标签</el-button>
          </el-col>
          <el-col>
            <el-card class="box-card">
              <div v-for="(item, index) in form.decode_body" :key="index" class="text item center">
                <el-col :span="3">序号：{{ index + 1 }}</el-col>
                <el-col :span="7">
                  <el-form-item
                    :key="'wxTagName:' + item.key"
                    :prop="'decode_body.' + index + '.wxTagName'"
                    :rules="[
                      {
                        required: true,
                        message: '微信模板标签不能为空',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="item.wxTagName" />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                    :key="'content:' + item.key"
                    :prop="'decode_body.' + index + '.content'"
                    :rules="[
                      {
                        required: true,
                        message: '本地对象模板不能为空',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input v-model="item.content" />
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-form-item>
                    <el-color-picker size="small" required v-model="item.color" placeholder="标签颜色" />
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-button size="mini" type="danger" @click.prevent="removeMapping(item)">删除</el-button>
                </el-col>
              </div>
            </el-card>
          </el-col>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.remark" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="form.status" active-text="启用" inactive-text="禁用" />
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import { getSceneTypes, editWechatTemplate, updateWechatTemplate, storeWechatTemplate, createWechatTemplate } from '@/api/wechat-templates'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [FormHelper],
  data() {
    return {
      sceneTypeOptions: [],
      sceneTypeTag: [],
      form: {
        template_id: '',
        mapping_body: '',
        decode_body: [],
        scene_type: 0,
        url: '',
        status: false,
        remark: '',
      },
      errors: {},
    }
  },
  created() {
    this.getSceneTypes()
  },
  methods: {
    async getSceneTypes() {
      const { data } = await getSceneTypes()
      this.sceneTypeOptions = data
    },
    async getData() {
      let data

      if (this.editMode) {
        ;({ data } = await editWechatTemplate(this.resourceId))
        this.fillForm(data)
      } else {
        ;({ data } = await createWechatTemplate())
      }

      this.showSceneTypeTag(this.form.scene_type)
    },
    /**
     * TODO:
     * - 前端数据验证未通过终止提交数据
     */
    async onSubmit() {
      this.form.mapping_body = JSON.stringify(this.form.decode_body)

      if (this.editMode) {
        await updateWechatTemplate(this.resourceId, this.form)
      } else {
        await storeWechatTemplate(this.form)
      }
    },
    async removeMapping(item) {
      var index = this.form.decode_body.indexOf(item)
      if (index !== -1) {
        this.form.decode_body.splice(index, 1)
      }
    },
    async addMapping(item) {
      if (this.form.decode_body.length >= 10) {
        this.$message({
          message: '搞错了吧，应该不会有这么多吧，添加很累的哦',
          type: 'warning',
        })
        return false
      }
      this.form.decode_body.push({
        color: '',
        content: '',
        wxTagName: '',
      })
    },
    async showSceneTypeTag(val) {
      var tags = this.sceneTypeOptions.filter(item => {
        return item.id === val
      })
      if (tags.length > 0) {
        this.sceneTypeTag = tags[0].fields
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
